import styled from 'styled-components';

const main_color = "#1e824c";

console.log(main_color)

export const TopBar = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: 50px;
  background: #ffffff;
  padding: 0;
  margin: 0;
  position: fixed;
  z-index: 999;
  border-bottom: 0.5px solid #1e824c;
`;

export const Logo = styled.img`
  height: 36px;
  margin: 7px;
`;
